import CustomModalLayout from "./CustomModalLayout";
import React, { SetStateAction, useState, useEffect } from "react";
import { Button } from "../../../shadcn/components/ui/button";
import GoogleSvg from "../../../icons/socialmedia/GoogleSvg";
import { registerWithMobile, initiateGoogleLogin } from "services";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { setGuestUser } from "store";
import { BetaForm as useBetaForm } from "@reusejs/react";

interface props {
  userLoggedin: boolean;
  loginModelOpen?: boolean;
  registerModelOpen: boolean;
  setLoginModalOpen: React.Dispatch<SetStateAction<boolean>>;
  setInputModalOpen: React.Dispatch<SetStateAction<boolean>>;
  setRegisterModal: React.Dispatch<SetStateAction<boolean>>;
  setAction: React.Dispatch<SetStateAction<string>>;
}

function RegisterModal({
  userLoggedin,
  registerModelOpen,
  setLoginModalOpen,
  setInputModalOpen,
  setRegisterModal,
  setAction,
}: props) {
  const router = useRouter();
  const dispatch = useDispatch();

  const form = useBetaForm({
    name: "",
    user_identity: "",
  });
  const mobileNumberRegEx: RegExp = /^[0-9]{10}$/;
  const nameRegex: RegExp = /^[a-zA-Z][a-zA-Z\s]*$/;
  const form_constraints = {
    name: {
      presence: {
        allowEmpty: false,
      },
      format: {
        pattern: nameRegex,
      },
    },
    user_identity: {
      presence: {
        allowEmpty: false,
      },
      format: {
        pattern: mobileNumberRegEx,
        message: "^Mobile number is not valid.",
      },
      length: {
        maximum: 10,
        message: "^Mobile number is too long (maximum is 10 characters)",
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  useEffect(() => {
    form.setField("user_identity", "");
    form.setField("name", "");
    form.removeError("name");
    form.removeError("user_identity");
  }, [registerModelOpen]);

  const hanldeSubmit = async () => {
    try {
      if (form.validate()) {
        await registerWithMobile(form).then((res: any) => {
          if (res.message === "Already Registered") {
            dispatch(setGuestUser({ guestUser: form.value }));
            setAction("verifyRegistration");
            setInputModalOpen(true);
            setRegisterModal(false);
          } else {
            dispatch(setGuestUser({ guestUser: form.value }));
            setAction("verifyRegistration");
            setInputModalOpen(true);
            setRegisterModal(false);
          }
        });
      }
    } catch (error) {
      console.log("check here error", error);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const data: any = await initiateGoogleLogin();
      router.push(data.redirect_to);
    } catch (error) {
      console.log("check here error", error);
    }
  };
  return (
    <CustomModalLayout
      userLoggedIn={userLoggedin}
      open={registerModelOpen}
      className={`pt-8 pb-[30px] ${!userLoggedin ? "min-h-[583px]" : ""}  `}
      childrenClassName="pl-4 pr-6"
      onClose={() => setRegisterModal(false)}
    >
      <div className="flex flex-col ">
        <p
          className={`font-openSans font-semibold ${
            userLoggedin ? "text-center" : ""
          } text-[24px] leading-8 text-black mb-[45px]`}
        >
          {userLoggedin ? "Log out" : "Register"}
        </p>
        {!userLoggedin && (
          <div>
            <p className="font-openSans font-normal text-web-body-lg leading-[22px] text-brand-bgBlack">
              Please enter your details
            </p>

            <form className="flex flex-col space-y-8 w-full mt-6">
              <div className="space-y-2">
                <label className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack">
                  Name
                </label>
                <input
                  type="text"
                  placeholder="Enter Name"
                  value={form.getField("name")}
                  onChange={(e) => form.setField("name", e.target.value)}
                  className="bg-[#F8F8F8] border-none h-10 p-2 w-full font-openSans focus:ring-brand-orange font-semibold text-web-body-sm leading-4 text-[#A1A0A0]"
                />
                {form.errors.get("name") ? (
                  <p className="mt-2 text-sm text-red-500">
                    {form.errors.get("name")[0]}
                  </p>
                ) : null}
              </div>
              <div className="space-y-2">
                <label className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack">
                  Mobile Number
                </label>
                <input
                  type="tel"
                  placeholder="+91"
                  value={form.getField("user_identity")}
                  onChange={(e) =>
                    form.setField("user_identity", e.target.value)
                  }
                  className="bg-[#F8F8F8] border-none h-10 outline-none p-2 focus:ring-brand-orange w-full font-openSans font-semibold text-web-body-sm leading-4 text-[#A1A0A0]"
                />
                {form.errors.get("user_identity") ? (
                  <p className="mt-2 text-sm text-red-500">
                    {form.errors.get("user_identity")[0]}
                  </p>
                ) : null}
              </div>
            </form>
          </div>
        )}

        {userLoggedin ? (
          <Button className="mt-12 w-full" onClick={() => alert("Logged out!")}>
            Confirm Logout
          </Button>
        ) : (
          <Button className="mt-12 w-full" onClick={() => hanldeSubmit()}>
            Next
          </Button>
        )}

        {!userLoggedin && (
          <div className="flex items-center w-full justify-center">
            <div className=" border-2 border-[#EEEEEE] mt-8 mb-[26px] w-full" />
            <p className="mx-2 font-openSans font-semibold text-web-body-sm leading-[18px] text-brand-textLightGrey">
              OR
            </p>
            <div className=" border-2 border-[#EEEEEE] mt-8 mb-[26px] w-full" />
          </div>
        )}

        {/* Signup/Google Button */}
        {!userLoggedin && (
          <Button
            onClick={() => handleGoogleLogin()}
            className=" w-full bg-white text-black border border-gray-300 hover:bg-gray-100 flex items-center justify-center space-x-4"
          >
            <GoogleSvg />
            {/* Google icon */}
            <span className=" font-openSans font-semibold text-web-body-lg leading-[22px] text-brand-textLightGrey">
              Sign in with Google
            </span>
          </Button>
        )}
        {!userLoggedin && (
          <div className="mt-[18px] flex items-center justify-center font-openSans font-normal text-web-body-sm leading-[14px] text-brand-bgBlack">
            <p>Already have an account?</p>
            <button
              onClick={() => {
                setRegisterModal(false);
                setLoginModalOpen(true);
              }}
              className="text-[#0873FF] ml-2"
            >
              Login
            </button>
          </div>
        )}
      </div>
    </CustomModalLayout>
  );
}

export default RegisterModal;
